import React from 'react';
import Paper from 'material-ui/Paper';
import { Plugin, Template, TemplateConnector } from '@devexpress/dx-react-core';
import { GroupingState, IntegratedGrouping } from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow,
    TableGroupRow,
} from '@devexpress/dx-react-grid-material-ui';
import GroupCell from './TableGroupCell';

// const GroupCell = ({ colSpan, ...restProps }) => {
//     return <TableGroupRow.Cell {...restProps} colSpan={colSpan - 2} column={{ title: null, name: null }} />;
// };

let uniqueVinCount = 0;

const digRows = (rows) => {
    if (!rows || !rows.length) return [];

    return rows.reduce((acc, row) => {
        if (!row.groupedBy) acc.push(row);
        return [...acc, ...digRows(row.collapsedRows)];
    }, []);
};

const getGroupRows = (group, rows) => {
    const { collapsedRows = [], compoundKey: groupKey } = group;
    const groupRowIndex = rows.findIndex(
        ({ compoundKey }) => compoundKey === groupKey
    );
    const nextGroupRowIndex =
        rows
            .slice(groupRowIndex + 1)
            .findIndex(
                ({ groupedBy, compoundKey }) =>
                    !!groupedBy && compoundKey.indexOf(groupKey) === -1
            ) + groupRowIndex;
    const expandedRows =
        nextGroupRowIndex < groupRowIndex
            ? rows.slice(groupRowIndex + 1)
            : rows.slice(groupRowIndex + 1, nextGroupRowIndex + 1);
    return [...collapsedRows, ...digRows(expandedRows)];
};

const GroupSummaryRow = () => {
    return (
        <Plugin>
            <Template
                name='tableRow'
                predicate={({ tableRow }) => tableRow.type === 'group'}
            >
                {params => (
                    <TemplateConnector>
                        {({ rows }) => {
                            const aggregated = getGroupRows(params.tableRow.row, rows).length;
                            return (
                                <TableGroupRow.Row {...params} row={params.tableRow.row}>
                                    {params.children}
                                    <Table.Cell>
                                        {aggregated}
                                    </Table.Cell>
                                    {
                                        params.tableRow.row.groupedBy === 'portfolio' ?
                                            <Table.Cell>
                                                {uniqueVinCount}
                                            </Table.Cell>
                                            :
                                            <Table.Cell />
                                    }
                                </TableGroupRow.Row>
                            );
                        }}
                    </TemplateConnector>
                )}
            </Template>
        </Plugin>
    );
};

export default class Demo extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            columns: this.props.columns,
            rows: this.props.rows,
            tableGroupColumnExtension: [
                { columnName: 'portfolio', showWhenGrouped: true, wordWrapEnabled: true },
                { columnName: 'brand', showWhenGrouped: true, wordWrapEnabled: true },
                { columnName: 'financeCompanyName', showWhenGrouped: true, wordWrapEnabled: true, expanded: false }
            ],
        };
    }
    render() {
        const { rows, columns, tableGroupColumnExtension } = this.state;
        uniqueVinCount = new Set(rows.map(item => item.vin)).size;

        return (
            <Paper className="report_table">
                <Grid
                    rows={rows}
                    columns={columns}
                >
                    <GroupingState
                        defaultGrouping={[{ columnName: 'portfolio' }, { columnName: 'brand' }, { columnName: 'financeCompanyName' }]}
                    />
                    <IntegratedGrouping />
                    <Table />
                    <TableHeaderRow />
                    <TableGroupRow
                        cellComponent={GroupCell}
                        columnExtensions={tableGroupColumnExtension}
                        indentColumnWidth={10}
                    />
                    <GroupSummaryRow />
                </Grid>
            </Paper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/helpers/AlertTable.js